<template>
  <l-map
    :center="center"
    :max-bounds="maxBounds"
    :zoom="zoom"
    :min-zoom="minZoom"
    :max-zoom="maxZoom"
    @click="onClick"
    @update:center="updateCenter"
  >
    <l-tile-layer :url="tileUrl" :attribution="attribution"></l-tile-layer>
    <slot></slot>
  </l-map>
</template>

<script>
import { LMap, LTileLayer } from "vue2-leaflet";
import { latLng, latLngBounds } from "leaflet";

export default {
  name: "BaseMap",
  components: {
    LMap,
    LTileLayer
  },
  props: {
    // LMap Properties
    center: {
      type: [Object, Array],
      default: () => latLng(22.28552, 114.15769)
    },
    maxBounds: {
      type: [Array, Object],
      default: () => {
        let southWest = latLng(22.083588284370954, 113.38577270507814);
        let northEast = latLng(22.63985416557479, 115.00350952148439);
        return latLngBounds(southWest, northEast);
      }
    },
    zoom: {
      type: Number,
      default: 14
    },
    minZoom: {
      type: Number,
      default: 10
    },
    maxZoom: {
      type: Number,
      default: null
    },
    // LTileLayer Properties
    tileUrl: {
      type: String,
      default: process.env.VUE_APP_MAP_HOST
    },
    attribution: {
      type: String,
      default: process.env.VUE_APP_MAP_ATTRIBUTION
    }
  },
  data: function() {
    return {
    }
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
    updateCenter(event) {
      this.$emit('updateCenter', event);
    }
  }
}
</script>

<style>
@import "~leaflet/dist/leaflet.css";
</style>
